import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import PMS from "../../../assets/img/Featured/pc-pms.png";
import GuestApp from "../../../assets/img/Featured/app-guest.png";
import BookApp from "../../../assets/img/Featured/app-booking.png";
import ExpressApp from "../../../assets/img/Featured/app-express.png";
import ExpressKiosk from "../../../assets/img/Featured/kiosk-express.png";

import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const LobbyPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page lobbyPage">
            <Header />
            <div className="page-header">Hotel</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Lobby</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Meet your guests where they are... in your lobby,
                    at the front desk, somewhere on-site at a check-
                    in/out kiosk, or anywhere on their own mobile
                    device. Put your guests in control with preference-
                    based stay options through unified booking, a
                    single itinerary view and your branded mobile
                    guest app.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Lobby", "PMS");
                    addFlow("PMS");
                    navigate("/solutions/pms")}}>
                    <div className="item-head">
                        <LogoMini />
                        PMS
                    </div>
                    <img src={PMS} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Lobby", "Guest App");
                    addFlow("Guest App");
                    navigate("/solutions/guest-app")}}>
                    <div className="item-head">
                        <LogoMini />
                        Guest App
                    </div>
                    <img src={GuestApp} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Lobby", "Book");
                    addFlow("Book");
                    navigate("/solutions/book")}}>
                    <div className="item-head">
                        <LogoMini />
                        Book
                    </div>
                    <img src={BookApp} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Lobby", "Express Mobile");
                    addFlow("Express Mobile");
                    navigate("/solutions/express-mobile")}}>
                    <div className="item-head">
                        <LogoMini />
                        Express Mobile
                    </div>
                    <img src={ExpressApp} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Lobby", "Express Kiosk");
                    addFlow("Express Kiosk");
                    navigate("/solutions/express-kiosk")}}>
                    <div className="item-head">
                        <LogoMini />
                        Express Kiosk
                    </div>
                    <img src={ExpressKiosk} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default LobbyPage;